
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { ChipMenuMixin } from '../chip-menu-mixin'
import { GoodRoadMixin } from './good-road-mixin'
import MGoodRoadItem from './m-good-road-item.vue'

@Options({
    components: {
        MGoodRoadItem
    }
})
export default class MGoodRoadPanel extends Mixins(
    GoodRoadMixin,
    ChipMenuMixin
) { }
